import React from 'react'
import styled from '@emotion/styled'
import { StaticQuery, graphql } from 'gatsby'
import GatsbyImage from 'gatsby-image'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { mq } from '@/utils/helpers'
import { mobile } from '@/utils/media'

class MV extends React.Component {
  render () {
    return (
      <StaticQuery
        query={query}
        render={data => {
          const sources = [
            {
              ...data.desktopImage.childImageSharp.fluid,
              media: '(min-width: 768px)'
            },
            data.mobileImage.childImageSharp.fluid
          ]
          return (
            <Root>
              <Image fluid={sources} alt="売れるECサイト構築。全力でサポートします。" />
            </Root>
          )
        }}
      />
    )
  }
}

export default ThemeConsumer(MV)

const Root = styled.div`
`
const Image = styled(GatsbyImage)`
  width: 100%;
  > div:first-of-type {
    padding-bottom: ${props =>
      `${100 / props.fluid[0].aspectRatio}% !important`
    };
    @media ${mq.and(mobile)} {
      padding-bottom: ${props =>
        `${100 / props.fluid[1].aspectRatio}% !important`
      };
    }
  }
`

export const query = graphql`
  query MVQuery {
    desktopImage: file(relativePath: { eq: "main.png" }) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    mobileImage: file(relativePath: { eq: "main-mobile.png" }) {
      childImageSharp {
        fluid(maxWidth: 970, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
